import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarrentextrafiltersComponent } from './carrentextrafilters.component';
import { AngularMaterialModule } from '@app/material.module';
import { MietzeitComponent } from './mietzeit/mietzeit.component';
import { DirectiveModule } from '@app/directives/directive.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectionbtnComponent } from './selectionbtn/selectionbtn.component';
import { CarrentselectedfiltersComponent } from './carrentselectedfilters/carrentselectedfilters.component';

@NgModule({
    declarations: [
        CarrentextrafiltersComponent,
        MietzeitComponent,
        SelectionbtnComponent,
        CarrentselectedfiltersComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        DirectiveModule,
    ],
    exports: [
        CarrentextrafiltersComponent,
        CarrentselectedfiltersComponent
    ]
})
export class CarrentextrafiltersModule { }
